import script from "./FAQsCoach.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQsCoach.vue?vue&type=script&setup=true&lang=js"

import "./FAQsCoach.vue?vue&type=style&index=0&id=55b7be46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b7be46"]])

export default __exports__